<app-button-advanced
  class="action-button"
  [action]="brushAction"
  [active]="(isBrushActive$ | async)!"
  [displayCorner]="settings.displayCorner"
  (clickedByCorner)="
    stateManagerProjectService.currentStateOfToolMenu = 'BRUSH';
    menuTrigger.openMenu()
  "
  matTooltip="{{ 'viewer.Tools.Brush' | translate }}"
  [matTooltipPosition]="'left'"
  [hotButton]="settings.displayHotKey ? 'B' : ''"
  [isMenuOpened]="menuTrigger.menuOpen"
  [matTooltipDisabled]="settings.disableTooltip || (isDisabled$ | async)"
  (contextmenu)="onBrushActionContextMenu($event)"
></app-button-advanced>

<span
  #menuTrigger="matMenuTrigger"
  class="hidden-menu-trigger"
  [matMenuTriggerFor]="(isDisabled$ | async) ? null : pointerSettingsMenu"
>
  <mat-menu
    #pointerSettingsMenu
    [xPosition]="settings.menuPosition.x"
    [yPosition]="settings.menuPosition.y"
    [hasBackdrop]="!settings.hideMenuBackdrop"
    class="tool-menu {{ settings.menuClass ?? '' }}"
    (closed)="updateComponent()"
  >
    <app-pointer-settings
      [class]="settings.menuItemClass ?? ''"
      [shape]="brushSettings.shape"
      [size]="brushSettings.size"
      [isToolActive]="(isBrushActive$ | async)!"
      [useHotKeys]="useHotKeys"
      (sizeChange)="onSizeChanged($event)"
      (shapeChange)="onShapeChanged($event)"
    ></app-pointer-settings>
  </mat-menu>
</span>
